export const McpChatState = {
  COLLAPSED: 'collapsed',
  SMALL: 'small',
  EXPANDED: 'expanded',
};

export const MCPCHAT_STORAGE_KEY = 'mcpchat:state';

export const McpChatEvent = {
  NAVIGATE: 'mcpchat:navigate',
};
export const MCPCHAT_DRAFT_CONVERSATION_KEY = '__draft__';
export const MCPCHAT_INITIAL_RENDER_WINDOW_SIZE = 40;
export const MCPCHAT_MESSAGE_BATCH_SIZE = 20;
export const MCPCHAT_TOP_LOAD_THRESHOLD_PX = 120;
export const MCPCHAT_BOTTOM_STICKY_THRESHOLD_PX = 96;
export const MCPCHAT_MAX_MARKDOWN_CACHE_ENTRIES = 500;
export const MCPCHAT_HISTORY_PAGE_SIZE = 10;

export const McpChatActionType = {
  QUICK_REPLY: 'quick_reply',
  DATA_GRID: 'data_grid',
  AGENT_RECOMMENDATIONS: 'agent_recommendations',
};

// eslint-disable-next-line tap/no-raw-text-js
export const DISCLAIMER_TEXT =
  'AI-generated responses may not always be accurate. Verify important data.';

// eslint-disable-next-line tap/no-raw-text-js
export const McpChatWidgetTarget = {
  CURRENT: 'current',
  EXISTING_DASHBOARD: 'existing_dashboard',
  NEW_DASHBOARD: 'new_dashboard',
  NEW_REPORT: 'new_report',
};

// eslint-disable-next-line tap/no-raw-text-js
export const McpChatQuickReplyOption = {
  EXISTING_DASHBOARD: 'Existing Dashboard',
  NEW_DASHBOARD: 'New Dashboard',
  NEW_REPORT_STUDIO: 'New Report Studio',
};

// eslint-disable-next-line tap/no-raw-text-js
export const McpChatStepStatus = {
  COMPLETED: 'completed',
  PLANNED: 'planned',
  IN_PROGRESS: 'in_progress',
  ERROR: 'error',
};

export const McpChatMessageRole = {
  USER: 'user',
  ASSISTANT: 'assistant',
};

export const McpChatBlockType = {
  STEPS: 'steps',
  TEXT: 'text',
  INSIGHT_SUMMARY: 'insight_summary',
  QUICK_REPLY: 'quick_reply',
  DATA_GRID: 'data_grid',
};

export const McpChatPlatformActionType = {
  CREATE_WIDGET: 'create_widget',
  EXECUTE_AGENT: 'execute_agent',
};

export const McpChatNavigationTargetType = {
  DASHBOARD: 'dashboard',
  REPORT: 'report',
};

export const MCPCHAT_TOKEN_PREFIX = '__MCPCHAT_TOKEN_';

export const McpChatScrollBehavior = {
  SMOOTH: 'smooth',
  INSTANT: 'instant',
};

export const McpChatActionChipVariant = Object.freeze({
  PRIMARY: 'primary',
  GHOST: 'ghost',
});
